import React, { useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import usePageTitle from '../../hooks/usePageTitle';
import { IPadsList } from './iPadsList';
import { IPadsGraph } from '../../components/iPadsGraph';
import useLocalizedCopy from '../../hooks/useLocalizedCopy';
import { usePageHeader } from '../../contexts/PageHeaderContext';

interface IPadsRoutesProps {
    viewType?: 'list' | 'dashboard';
}

export function IPadsRoutes({ viewType = 'list' }: IPadsRoutesProps) {
    const { copy } = useLocalizedCopy();
    const { setPageHeader } = usePageHeader();
    
    usePageTitle(copy.IPads.list.title);
    
    const isListView = viewType === 'list';
    const isDashboardView = viewType === 'dashboard';

    // Create navigation items with useMemo to prevent recreating on every render
    const navigationItems = useMemo(() => (
        <div className="flex gap-4 text-sm">
            <Link 
                to="/ipads/list" 
                className={isListView ? "text-primary font-semibold" : "text-gray-600 hover:text-primary"}
            >
                List View
            </Link>
            <Link 
                to="/ipads/dashboard"
                className={isDashboardView ? "text-primary font-semibold" : "text-gray-600 hover:text-primary"}
            >
                Dashboard
            </Link>
        </div>
    ), [isListView, isDashboardView]);

    useEffect(() => {
        setPageHeader(copy.IPads.list.title, navigationItems);
        
        return () => setPageHeader(null);
    }, [copy.IPads.list.title, navigationItems, setPageHeader]);

    return (
        <div className="container-fixed">
            {isListView ? <IPadsList /> : <IPadsGraph />}
        </div>
    );
}